import { useEffect, useRef } from "react";
import GoogleMeetServices from "../../../services/GoogleMeetService";

export default function GoogleCallback() {
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;

    const params = new URLSearchParams(window.location.search);
    const code = params.get("code");
    if (!code) return;

    done.current = true;

    // state holds the tenant subdomain origin so postMessage reaches the correct window
    const stateParam = params.get("state");
    const openerOrigin = stateParam ? decodeURIComponent(stateParam) : window.location.origin;

    GoogleMeetServices.exchangeCode(code)
      .then(token => {
        window.opener.postMessage(
          { type: "GOOGLE_OAUTH_SUCCESS", token },
          openerOrigin
        );
        window.close();
      });
  }, []);

  return <p>Connecting to Google…</p>;
}
